import type { SortDirection } from "@suse-o11y/sort-by";

const ALL_SORT_DIRECTIONS = ["desc", "asc"] as const satisfies ReadonlyArray<SortDirection>;

export { ALL_SORT_DIRECTIONS };
